export { EventBlockInput as Input } from './input'
export { EventBlockPropertiesPanel as PropertiesPanel } from './properties-panel'